import { useActivateDiscountsMutation } from "@/components/server/EditSuscription/DeleteAccount/api";
import type { Gift } from "@/components/server/EditSuscription/DeleteAccount/types";
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
} from "@/components/ui/dialog";
import type { DeleteSuscriptionPost } from "@/services/types";
import { useEffect, useState } from "react";
import { AgradecimientoOferta } from "./AgradecimientoOferta";
import { MarkdownCustom } from "./MarkdownCustom";

type OfertaEspecialProps = {
    open: boolean;
    onClose: () => void;
    deleteSuscriptionData: DeleteSuscriptionPost;
    gift: Gift;
    onConfirm: (data: DeleteSuscriptionPost) => void;
    isLoading: boolean;
};

export const OfertaEspecial = ({
    open,
    onClose,
    gift,
    deleteSuscriptionData,
    onConfirm,
    isLoading,
}: OfertaEspecialProps) => {
    const [acepted, setAcepted] = useState(false);
    const activateDiscountsMutation = useActivateDiscountsMutation();
    useEffect(() => {
        if (activateDiscountsMutation.isSuccess) {
            setAcepted(true);
            onClose();
        }
    }, [activateDiscountsMutation.isSuccess, onClose]);
    return (
        <>
            <AgradecimientoOferta
                open={acepted}
                setClose={() => setAcepted(false)}
                gift={gift}
            />
            <Dialog open={open} onOpenChange={onClose}>
                <DialogContent className="sm:max-w-md">
                    <DialogHeader>
                        <h2 className="text-center text-2xl font-semibold">
                            {gift.card.title}
                        </h2>
                    </DialogHeader>
                    <div className="text-center py-4">
                        <MarkdownCustom>{gift.card.body}</MarkdownCustom>
                    </div>
                    <DialogFooter className="flex flex-col sm:flex-row gap-2">
                        <Button
                            variant="outline"
                            disabled={
                                activateDiscountsMutation.isPending || isLoading
                            }
                            onClick={() => onConfirm(deleteSuscriptionData)}
                            className="flex-1"
                        >
                            Cancelar Suscripción
                        </Button>
                        <Button
                            onClick={() => {
                                activateDiscountsMutation.mutate({
                                    terminationReason:
                                        deleteSuscriptionData.termination_reason,
                                });
                            }}
                            className="flex-1"
                            disabled={
                                activateDiscountsMutation.isPending || isLoading
                            }
                        >
                            {activateDiscountsMutation.isPending
                                ? "Activando..."
                                : "Activar descuento"}
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </>
    );
};
